import React, { useState } from 'react';
import {
  Text,
  PopoverInteractiveWrapper,
  Popover,
} from '@razorpay/blade/components';
import { useRayContext } from 'components/RayAiBot/context/RayContext';
import { rayActionTypes } from 'components/RayAiBot/context/data';
import { ThemedBladeProvider } from 'ThemedBladeProvider';
import { getStaticMediaUrl } from 'utils/Urls';
import RayLogo from 'assets/ray/ray_logo_only_image.png';
import { EntryPointWrapper } from './styles';
import { SuggestionBox } from './SuggestionBox';

export const SalaryExplainerEntryPoint = () => {
  const { dispatch, state } = useRayContext();
  const [shouldShowPopover, setShouldShowPopover] = useState(state.chatId ? false : true);

  const openChat = () => {
    dispatch({
      type: rayActionTypes.SET_SHOW_RAY_CHAT,
      payload: true,
    });
    setShouldShowPopover(false);
  };

  const handleOpenChatOrPopover = () => {
    if (state.chatId) {
      openChat();
    } else {
      setShouldShowPopover(true);
    }
  };

  const handleClosePopover = () => {
    setShouldShowPopover(false);
  };

  return (
    <Popover
      isOpen={shouldShowPopover}
      title=""
      content={<SuggestionBox onClose={handleClosePopover} />}
      placement="right"
      onOpenChange={({ isOpen }) => setShouldShowPopover(isOpen)}>
      <PopoverInteractiveWrapper>
        <EntryPointWrapper onClick={handleOpenChatOrPopover}>
          <img src={getStaticMediaUrl(RayLogo)} width="16px" height="auto" alt="Ray AI Logo" />
          {shouldShowPopover ? null : (
            <Text size="large" weight="medium" color="surface.text.gray.subtle">
              Ask AI
            </Text>
          )}
        </EntryPointWrapper>
      </PopoverInteractiveWrapper>
    </Popover>
  );
};

const EntryPointWithProvider = () => {
  return (
    <ThemedBladeProvider>
      <SalaryExplainerEntryPoint />
    </ThemedBladeProvider>
  );
};

export default EntryPointWithProvider;
